import { Input, Select } from "common/InputForm";
import imgUploadToCloudFun from "components/modals/imgUploadAndGetUrl";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { editUserApi, userDetailApi } from "services/user";
import { ImagePreview } from "utils/imagePreviewURLConverter";
import "./userManagement.scss";
import { formatDateForInput } from "utils/common";
import { userPlaceholder } from "assets/icons";

const EditUserManagement = () => {
  const { userId } = useParams();
  const [error, setError] = useState({});
  const navigate = useNavigate()
  // -----------------------------image upload related
  // -----cloud img
  const [imgInputState, setImageInputState] = useState("");
  // -------image preview related state
  const [imgPreviewState, seImgPreviewState] = useState(null);

  const imgUploadFunction = async (e) => {
    if (!e?.target?.files[0]?.type.includes("image/")) {
      // ------for image preview i am string selected image data
      // -set error
      setError((stateProp) => ({
        ...stateProp,
        imgErrorOccur: "Please Choose Image file not others",
      }));
    } else {
      try {
        const data = await imgUploadToCloudFun(e?.target?.files[0]);
        // console.log("1st data?.data[0]:-------->", data?.data[0]);
        if (data?.status === 200) {
          //   console.log("2nd-------data?.data[0]:-------->", data?.data[0]);
          setImageInputState(data?.data[0]);
          seImgPreviewState(e?.target?.files[0]);
        }
      } catch (error) {
        console.log("error while uploading and getting data", error);
      }
    }
  };
  // console.log('imgPreviewState', imgPreviewState)
  // -----------user form data
  const [userName, setUserName] = useState("");
  const [userNumber, setUserNumber] = useState(0);
  const [userCountryCode, setUserCountryCode] = useState(0);
  const [userEmailId, setUserEmailId] = useState("");
  const [gender, setGender] = useState("");
  const [userDOB, setUserDOB] = useState("");
  const [isMarried, setIsMarried] = useState("");
  // console.log('userDOB', userDOB)
  const [userData, setUserData] = useState({});



  const fetchSelectedUserDetails = async () => {
    try {
      const {
        data: { status, code, data },
      } = await userDetailApi(userId);
      if (status || code === 200) {
        setUserData(data);
        seImgPreviewState(data?.image);
        setImageInputState(data?.image || '')
        setUserName(data?.fullName);
        setUserNumber(data?.phone);
        setUserCountryCode(data?.countryCode);
        setUserEmailId(data?.email);
        setGender(data?.gender);
        setUserDOB(data?.dob);
        setIsMarried(data?.martialStatus);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSelectedUserDetails();
  }, []);

  // -----------submit-----------
  const doSubmit = async () => {
    const dataToSend = {
      fullName: userName,
      gender: gender,
      martialStatus: isMarried,
      // image: imgInputState,
      ...(imgPreviewState?.name && { image: imgInputState }),
      dob: userDOB,
      email: userEmailId,
      // phone: `${userCountryCode}${userNumber}`,
    }
    try {
      const {
        data: { status, code },
      } = await editUserApi(userId, dataToSend);
      if (status || code === 200) {
        // navigate("/user-management");
        navigate(-1)
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      {/* -------user header */}
      <div>
        <p>
          <Link to={-1} style={{ color: "#800080" }}>
            <span>User Details</span>/
          </Link>
          edit user-detail
        </p>
      </div>

      <div className="card user-mgm-details-container">
        <div className="userDetails-container">
          <div className="left-side">
            <div className="add_model">
              <input
                onChange={imgUploadFunction}
                type="file"
                accept="image/*"
                className="form-control"
              />
            </div>

            {!imgInputState.length && error["imgEmptyErrorMsg"] && (
              <span className="red-color">{error["imgEmptyErrorMsg"]}</span>
            )}
            {error["imgErrorOccur"] && (
              <p className="red-color">{error["imgErrorOccur"]}</p>
            )}

            {/* ------image preview Container div */}
            <div className="previewImgContainer">
              {imgPreviewState ? <ImagePreview file={imgPreviewState} className='rounded-circle' /> :
                <img src={userPlaceholder} alt="Preview" width={200} className="rounded-circle" />}
            </div>

            <p>{userData?.customerId}</p>
          </div>

          {/* ----end of left side */}
          <div className="right-side">
            <h3 style={{ color: "black", margin: "0rem 0rem 1rem 0rem" }}>
              Personal Data
            </h3>
            <div style={{ marginTop: "1rem" }}>
              <Input
                value={userName}
                label="Name"
                placeholder="Enter Name"
                onChange={(e) => {
                  setUserName(e.target.value);
                }}
              />
            </div>

            <div style={{ marginTop: "1rem" }}>
              {/* <Input
                label="Country Code"
                type="number"
                value={userCountryCode}
                onKeyDown={(e) => {
                  if (["e", "E", "-", "."].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  setUserCountryCode(e.target.value);
                }}
              /> */}

              {/* <Input
                label="Country Code"
                type="text"
                placeholder="Country Code"
                value={userCountryCode}
                onKeyDown={(e) => {
                  // Prevent letters and invalid characters but allow "+" as first char
                  const allowedKeys = [
                    "Backspace",
                    "ArrowLeft",
                    "ArrowRight",
                    "Tab",
                    "+",
                  ];
                  if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  setUserCountryCode(e.target.value);
                }}
              /> */}
              <Input
                label="Country Code"
                type="text"
                placeholder="Country Code"
                value={userCountryCode}
                onKeyDown={(e) => {
                  const allowedKeys = [
                    "Backspace",
                    "ArrowLeft",
                    "ArrowRight",
                    "Tab",
                  ];
                  if (
                    !/[0-9]/.test(e.key) &&
                    !allowedKeys.includes(e.key) &&
                    !(e.key === "+" && e.target.selectionStart === 0)
                  ) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  let value = e.target.value.replace(/\s+/g, ""); // remove spaces

                  // Allow only "+" at beginning and digits after
                  if (/^\+?\d*$/.test(value)) {
                    if (value.length <= 5) {
                      setUserCountryCode(value);
                    }
                  }
                }}
              />

            </div>

            <div style={{ marginTop: "1rem" }}>
              {/* <Input
                label="Ph. Number"
                type="number"
                placeholder="Phone number"
                value={userNumber}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-", "."].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  setUserNumber(e.target.value);
                }}
              /> */}

              <Input
                label="Ph. Number"
                type="text"
                placeholder="Phone number"
                maxLength={10}
                value={userNumber}
                inputMode="numeric" // mobile shows number keyboard
                onKeyDown={(e) => {
                  // Allow only numbers and navigation keys
                  const allowedKeys = [
                    "Backspace",
                    "ArrowLeft",
                    "ArrowRight",
                    "Tab",
                  ];
                  if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  const numericOnly = e.target.value.replace(/\D/g, ""); // remove non-digits
                  setUserNumber(numericOnly.slice(0, 10)); // enforce max 10 digits
                }}
              />

            </div>
            <div style={{ marginTop: "1rem" }}>
              <Input
                label="Email"
                type="email"
                placeholder="Email"
                value={userEmailId}
                onChange={(e) => {
                  setUserEmailId(e.target.value);
                }}
                maxLength={40}
              />
            </div>

            <div style={{ marginTop: "1rem" }}>
              <Input
                label="DOB"
                type="date"
                value={formatDateForInput(userDOB)}
                onChange={(e) => {
                  setUserDOB(e.target.value);
                }}
              />
            </div>

            <div style={{ marginTop: "1rem" }}>
              <Select
                label="Gender"
                value={gender}
                onChange={(e) => {
                  setGender(e.target.value);
                }}
              >
                <option value="">select Gender</option>
                <option value="MALE">Male</option>
                <option value="FEMALE">Female</option>
                <option value="OTHERS">Others</option>
              </Select>
            </div>

            <div style={{ marginTop: "1rem" }}>
              <Select
                label="Marital Status"
                value={isMarried}
                onChange={(e) => {
                  setIsMarried(e.target.value);
                }}
              >
                <option value="">select marital Status</option>
                <option value="SINGLE">Single</option>
                <option value="MARRIED">Married</option>
              </Select>
            </div>
          </div>
        </div>

        {/* ---submit button holder */}
        <div style={{ textAlign: "center", marginTop: "3rem" }}>
          <button onClick={doSubmit} type="button" className="button">
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditUserManagement;
